import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Button } from 'components/util'
import styles from './_signup.css'
import * as authActions from 'services/auth/actions'
import * as authSelectors from 'services/auth/selectors'
import * as bootupSelectors from 'services/bootup/selectors'
import { getWechatSignupUrl } from 'shared/urls'
import { isWechatAuthFromCookies } from 'shared/auth'

const mapStateToProps = state => ({
  isWechatAuth: authSelectors.selectIsWechatAuth(state),
  wechatApiConfig: bootupSelectors.selectWechatApiConfig(state),
})

const mapDispatchToActions = {
  ...authActions,
}

class WechatSignupButton extends React.Component {
  componentWillMount () {
    if (isWechatAuthFromCookies(document.cookie)) {
      this.props.setWechatAuthState()
    }
  }

  render () {
    return (
      <div className={styles.wechat}>
        <Button
          disabled={this.props.disabled}
          type='wechat'
          icon='wechat_circle'
          className={styles.button}
          onClick={() => {
            window.location.href = getWechatSignupUrl(window, this.props.wechatApiConfig)
          }}>
          <FormattedMessage
            id='auth.signup.signup_with_wechat'
            defaultMessage='Sign up with Wechat' />
        </Button>
      </div>
    )
  }
}

WechatSignupButton.propTypes = {
  disabled: PropTypes.bool,
  isWechatAuth: PropTypes.bool,
  setWechatAuthState: PropTypes.func,
  wechatApiConfig: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToActions)(WechatSignupButton)
